<div #overlay class="overlay">
    <div id="payment-form"></div>
</div>
<div class="preloader"></div>

<div *ngIf="order">
    <div class="card">
        <div class="order-header">
            <div class="order-header__actions d-flex">
                <a routerLink="/account/orders" class="btn btn-xs btn-secondary m-2" *ngIf="userDetails">{{"back_to_list"|translate}}</a>
                <a [href]="printOrder()" class="btn btn-xs btn-secondary m-2" target="_blank" *ngIf="userDetails">{{"print_order"|translate}}</a>
                <a *ngIf="order.companyData?.bankAccount?.iban && order?.companyData?.showBenefitPay && order?.paidStatus=='np'  && userDetails" (click)="payWithBenefit()" class="btn btn-xs btn-secondary ms-2">{{"pay_with_benefit"|translate}}</a>
                <a class="m-2 btn btn-xs btn-primary" *ngIf="order?.can?.cancel == true && userDetails" (click)="openCancelDialog()">{{(order?.orderStatusData?.code == 'N'? "cancel_order":'request_cancel')|translate}}</a>
            </div>
            <h5 class="order-header__title">{{"order"|translate}} #{{ order?.orderId }}</h5>
            <div class="order-header__subtitle">
                {{"created_at"|translate}} <mark class="order-header__date">{{ order?.creationDate |date:'medium' }}</mark>
                {{"order_status"|translate}} <mark class="order-header__status">{{ (order?.statusData) ? order?.statusData?.name?.en : '' }}</mark>.
            </div>
            <div class="order-header__subtitle">
                {{"service_provider"|translate}} <mark class="order-header__status">{{ translateHelper.localize(order.professionalData?.profession?.title) || order.professionalData?.name }}</mark>.
            </div>
            <mat-divider *ngIf="order?.cancellation?.status" class="border-gray-400 w-1/3 min-w-64 mt-2"></mat-divider>
            <div class="text-sm" *ngIf="order?.cancellation?.status"> {{"cancel_order"|translate}}:</div>
            <div class="request-sent" *ngIf="order?.cancellation?.status == 'requested'">{{ "request_cancellation_sent" | translate }}.</div>
            <div class="request-approved" *ngIf="order?.cancellation?.status == 'approved'">{{ "request_cancellation_approved" | translate }}.</div>
            <div class="request-sent" *ngIf="order?.cancellation?.status == 'rejected'">{{ "request_cancellation_rejected" | translate }}</div>
            <div *ngIf="order?.cancellation?.response?.timestamp" class="text-sm">{{"response_date"|translate}} {{ order?.cancellation?.response?.timestamp |date:'medium' }}</div>
            <div class="text-sm" *ngIf="order?.cancellation?.response?.note"> {{"cancel_response_note"|translate}}: {{ order?.cancellation?.response?.note }}</div>



            <app-cancel-order-information *ngIf="order?.cancellation" [cancelData]="order?.cancellation"></app-cancel-order-information>

        </div>
        <div class="card-divider"></div>
        <div class="card-table">
            <div class="table-responsive-sm">
                <table>
                    <thead>
                        <tr>
                            <th>{{"product"|translate}}</th>
                            <th>{{"total"|translate}}</th>
                        </tr>
                    </thead>
                    <tbody class="card-table__body card-table__body--merge-rows">
                        <tr *ngFor="let item of order.services">
                            <td><a [routerLink]="serviceLink(item)">{{ translateHelper.localize(item?.name)}}</a> × {{ item.amount }}
                                <app-booking-line-summary [line]="item"></app-booking-line-summary>

                                <div *ngIf="item.options?.length > 0||item.variant" class="order-list__options">
                                    <app-options-details [options]="item.options" [variant]="item.variant"></app-options-details>
                                </div>

                            </td>
                            <td>{{ item.total|currencyFormat }}</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="order.additionalLines?.length > 0" class="card-table__body card-table__body--merge-rows">
                        <tr>
                            <th>{{"subtotal"|translate}}</th>
                            <td>{{ order.subtotal|currencyFormat }}</td>
                        </tr>
                        <tr *ngFor="let line of order.additionalLines">
                            <th>{{ line.label }}</th>
                            <td>{{ line.total|currencyFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="justify-end mb-2 me-2 sm:flex flex-row">
            <div class="float-left ms-3 sm:items-start me-2 font-bold">
                <div>{{"subtotal"|translate}}:</div>
                <div *ngIf="order.discountTotal">{{"discount"|translate}}:</div>
                <div>{{"shipping"|translate}}: </div>
                <div *ngIf="order.taxTotal">{{"tax"|translate}}:</div>
                <div>{{"total"|translate}}:</div>
            </div>
            <div class="float-right sm:items-end">
                <div>{{ order?.subtotal|currencyFormat }}</div>
                <div *ngIf="order.discountTotal">{{ order?.discountTotal|currencyFormat }}</div>
                <div>{{ order?.shippingTotal|currencyFormat }}</div>
                <div *ngIf="order.taxTotal">{{ order?.taxTotal|currencyFormat }}</div>
                <div>{{ order?.total|currencyFormat }}</div>
            </div>
        </div>
        <div class="flex flex-col mx-2" *ngIf="order.expectedTimeRange">
            <div>{{"expected_time"|translate}}</div>
            <div class="flex flex-row">
                <div>{{"from"|translate}}:{{order.expectedTimeRange.start|date: "medium"}}</div>
                <div class="mx-2">{{"to"|translate}}:{{order.expectedTimeRange.end|date: "medium"}}</div>
            </div>
        </div>
        <div class="flex flex-wrap m-2 mx-4 justify-end">
            <!-- <div class="font-bold mt-2">{{"payment_methods"|translate}}</div> -->
            <button *ngIf="userDetails" [disabled]="!(order.professionalData?.bankAccount?.iban && order?.professionalData?.showBenefitPay && order?.paidStatus=='np' ) " (click)="payWithBenefit()" class="btn btn-xs btn-secondary ms-2">{{"pay_with_benefit"|translate}}</button>
            <button *ngIf="order" [routerLink]="['/checkout-s', order.orderId, 'professional']" class="btn btn-xs btn-secondary ms-2">{{"payment"|translate}}</button>
        </div>
    </div>

    <mat-tab-group dynamicHeight (selectedIndexChange)="selectedChange($event)">
        <mat-tab [label]="'Details'">
            <div *ngIf="order.address" class="row mt-3 no-gutters mx-n2">
                <div class="col-sm-6 col-12 px-2">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"address"|translate}}</div>
                            <div class="address-card__name">{{ order.address.name}}</div>
                            <div class="address-card__row">
                                {{ order.address.country }}<br>
                                <!-- {{ order.address.postcode }}, --> {{ order.address.city }}<br>
                                {{ order.address.address }}
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"phone"|translate}}</div>
                                <div class="address-card__row-content">{{ order.address.phone }}</div>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"email_address"|translate}}</div>
                                <div class="address-card__row-content">{{ order?.userData?.email || order?.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row mt-3 no-gutters mx-n2">
                <div *ngIf="order?.orderPayments?.length > 0" class="col-sm-6 col-12 px-2">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"payment_details"|translate}}</div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"payment_type"|translate}}</div>
                                <ng-container *ngFor="let payment of order?.orderPayments">
                                    <div class="address-card__row-content">{{payment.type}}</div>
                                </ng-container>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"paid_status"|translate}}</div>
                                <div class="address-card__row-content">{{paidStatuses[order?.paidStatus] || paidStatuses['np']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 no-gutters mx-n2">
                <div *ngIf="order?.promotions?.length > 0 ||  order?.vouchers?.length > 0 " class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"promotions"|translate}}</div>

                            <div class="address-card__row" *ngFor="let promotion of order?.promotions">
                                <div class="address-card__row-title promotion">{{promotion.title.en}}</div>
                                <div class="address-card__row-content">{{"total_discounted"|translate}}:{{promotion.total}}
                                </div>
                            </div>
                            <div *ngIf=" order?.vouchers?.length > 0" class="address-card__row">
                                <div class="address-card__row-title">{{"applied_coupons_vouchers"|translate}}</div>
                                <ng-container *ngFor="let coupon of order.appliedCoupons">
                                    <div class="address-card__row-content">{{coupon}}</div>
                                </ng-container>
                                <ng-container *ngFor="let vouchers of order.vouchers">
                                    <div class="address-card__row-content">{{vouchers.code}} - {{"paid_total"|translate}}:
                                        {{vouchers.total|currencyFormat}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>

        <!-- <mat-tab *ngIf="siteService.features?.orderMessages">
            <ng-template mat-tab-label>
                <span [matBadge]="order.unreadUserMessages? '*':null" matBadgeColor="warn" matBadgeOverlap="false">Messages</span>
              </ng-template>
            <div class="card">
                <app-order-messages [order]="order"></app-order-messages>
            </div>
        </mat-tab> -->
    </mat-tab-group>


</div>